import {FC} from 'react';

import {WorkDataReadWriteForm} from './WorkDataReadWriteForm';
import {IWorkContentFull, WorkContentType} from '../../../../shared/types/workContent.types';
import {WorkDataDocumentsForm} from './WorkDataDocumentsForm';

interface IWorkDataItemContent {
  item: {
    type: WorkContentType;
    fields: IWorkContentFull[];
  };
  formPart: Record<
    string,
    {
      type: string;
      value?: string;
    }
  >;
  isEditable: boolean;
}

export const WorkDataItemContent: FC<IWorkDataItemContent> = ({item, isEditable}) => {
  if (item.type === WorkContentType.DOCUMENTS) {
    return <WorkDataDocumentsForm item={item} isEditable={isEditable} />;
  } else {
    return <WorkDataReadWriteForm item={item} isEditable={isEditable} />;
  }
};
